import React from 'react';

const Video = ({ url }) => {
  return <span>{url ? url : 'Add video url'}</span>;
};

export default Video;
